import { render } from "./MarkdownTextDev.vue?vue&type=template&id=b59c3c5e"
import script from "./MarkdownTextDev.vue?vue&type=script&lang=js"
export * from "./MarkdownTextDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__